import type { PixelModule } from '@/runtime/types';
import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

export class PrivacyModule implements PixelModule {
  readonly name = 'privacy' as const;

  init(context: PixelRuntimeContext): void {
    context.logger.debug('[Pixel] Privacy module initialized');
  }

  destroy(): void {}
}
